/* Felix Assouline Cigars: theme behaviour for Shopify. No dependencies.
   Built by tools/build_shopify.py from the site's own script; the cart, product options, sign-ups and the
   Society talk to Shopify (the Ajax Cart API, customer and contact forms, Shopify Subscriptions).
   In this store each size of a cigar is a product, and its variants are the boxes. */
(function () {
  'use strict';

  var FA = window.FA || {};
  var R = FA.routes || {};
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var MIN_AGE = FA.minAge || 21;

  /* ---------------------------------------------------------------- helpers */
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function on(el, ev, fn, opt) { if (el) el.addEventListener(ev, fn, opt); }
  function money(n) {
    n = Number(n || 0);
    var whole = Math.abs(n - Math.round(n)) < 0.005;
    return '$' + n.toLocaleString('en-US', { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2 });
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function handleize(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/['’]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  var store = {
    get: function (k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.localStorage.setItem(k, v); } catch (e) { /* storage blocked */ } },
    del: function (k) { try { window.localStorage.removeItem(k); } catch (e) { /* storage blocked */ } },
    sget: function (k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } },
    sset: function (k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) { /* storage blocked */ } }
  };
  function params() { var o = {}; try { new URLSearchParams(location.search).forEach(function (v, k) { o[k] = v; }); } catch (e) { /* old browser */ } return o; }
  var QS = params();

  var toastTimer;
  function toast(msg) {
    var t = $('#toast'); if (!t) return;
    t.textContent = msg; t.classList.add('show');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.classList.remove('show'); }, 3600);
  }
  function track() { /* Shopify's own analytics records visits and sales; nothing to send from here */ }

  /* Shopify Ajax API: JSON in, JSON out */
  function api(path, body) {
    var opt = { credentials: 'same-origin', headers: { 'Accept': 'application/json' } };
    if (body) { opt.method = 'POST'; opt.headers['Content-Type'] = 'application/json'; opt.body = JSON.stringify(body); }
    return fetch(path, opt).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw j; return j; });
    });
  }

  /* ---- layer handling */
  var openLayers = [];
  function focusables(el) {
    return $$('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])', el)
      .filter(function (x) { return x.offsetParent !== null || x === document.activeElement; });
  }
  function openLayer(el, opts) {
    opts = opts || {};
    var layer = { el: el, opts: opts, returnTo: document.activeElement };
    openLayers.push(layer);
    el.hidden = false;
    if (opts.scrim) { opts.scrim.hidden = false; }
    document.body.classList.add('locked');
    void el.offsetWidth; // commit the un-hidden state so the opening transition runs
    el.classList.add('open'); if (opts.scrim) opts.scrim.classList.add('open');
    var f = opts.focus ? $(opts.focus, el) : focusables(el)[0];
    if (f) f.focus({ preventScroll: true });
    if (opts.trigger) opts.trigger.setAttribute('aria-expanded', 'true');
  }
  function closeLayer(el) {
    var idx = -1;
    openLayers.forEach(function (l, i) { if (l.el === el) idx = i; });
    if (idx < 0) return;
    var layer = openLayers.splice(idx, 1)[0];
    el.classList.remove('open');
    if (layer.opts.scrim) layer.opts.scrim.classList.remove('open');
    if (layer.opts.trigger) layer.opts.trigger.setAttribute('aria-expanded', 'false');
    var done = function () { el.hidden = true; if (layer.opts.scrim) layer.opts.scrim.hidden = true; };
    if (REDUCED) done(); else setTimeout(done, 450);
    if (!openLayers.length) document.body.classList.remove('locked');
    if (layer.returnTo && layer.returnTo.focus) layer.returnTo.focus({ preventScroll: true });
  }
  on(document, 'keydown', function (e) {
    var top = openLayers[openLayers.length - 1];
    if (!top) return;
    if (e.key === 'Escape') { e.preventDefault(); closeLayer(top.el); return; }
    if (e.key === 'Tab') {
      var f = focusables(top.el); if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---- header */
  var hdr = $('#hdr');
  function onScroll() { if (hdr) hdr.classList.toggle('solid', window.scrollY > 30); }
  on(window, 'scroll', onScroll, { passive: true }); onScroll();

  var menuBtn = $('#menu-btn'), mnav = $('#mnav');
  on(menuBtn, 'click', function () { openLayer(mnav, { trigger: menuBtn }); });
  $$('[data-close-menu]').forEach(function (b) { on(b, 'click', function () { closeLayer(mnav); }); });
  $$('#mnav a').forEach(function (a) { on(a, 'click', function () { closeLayer(mnav); }); });
  $$('.mn-toggle').forEach(function (b) {
    on(b, 'click', function () {
      var panel = document.getElementById(b.getAttribute('aria-controls')), open = b.getAttribute('aria-expanded') !== 'true';
      b.setAttribute('aria-expanded', String(open)); panel.hidden = !open;
    });
  });

  /* desktop menus: click or keyboard opens, hover opens with a pointer, Escape and outside clicks close */
  (function menus() {
    var tops = $$('.nav-top[aria-controls]'); if (!tops.length) return;
    var hoverTimer, openBtn = null;
    var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    function panelOf(b) { return document.getElementById(b.getAttribute('aria-controls')); }
    function close(b, focus) {
      if (!b) return;
      var m = panelOf(b);
      b.setAttribute('aria-expanded', 'false'); m.classList.remove('open');
      setTimeout(function () { if (b.getAttribute('aria-expanded') === 'false') m.hidden = true; }, REDUCED ? 0 : 220);
      if (openBtn === b) openBtn = null;
      if (focus) b.focus();
    }
    function open(b) {
      if (openBtn && openBtn !== b) close(openBtn);
      var m = panelOf(b);
      m.hidden = false; void m.offsetWidth; m.classList.add('open');
      b.setAttribute('aria-expanded', 'true'); openBtn = b;
    }
    tops.forEach(function (b) {
      var li = b.parentNode;
      on(b, 'click', function () { if (b.getAttribute('aria-expanded') === 'true') close(b); else open(b); });
      if (finePointer) {
        on(li, 'mouseenter', function () { clearTimeout(hoverTimer); hoverTimer = setTimeout(function () { open(b); }, 90); });
        on(li, 'mouseleave', function () { clearTimeout(hoverTimer); hoverTimer = setTimeout(function () { close(b); }, 220); });
      }
      on(li, 'keydown', function (e) { if (e.key === 'Escape' && b.getAttribute('aria-expanded') === 'true') { e.stopPropagation(); close(b, true); } });
      on(li, 'focusout', function (e) { if (e.relatedTarget && !li.contains(e.relatedTarget)) close(b); });
    });
    on(document, 'click', function (e) { if (openBtn && !openBtn.parentNode.contains(e.target)) close(openBtn); });
  })();

  /* ------------------------------------------------------- current page */
  (function navCurrent() {
    var p = location.pathname.replace(/\/$/, '') || '/';
    $$('.nav a[href], .mn-list a[href], .drop a[href]').forEach(function (a) {
      var h = (a.getAttribute('href') || '').split(/[?#]/)[0].replace(/\/$/, '') || '/';
      if (h === p) a.setAttribute('aria-current', 'page');
    });
    var brand = /^\/products\//.test(p) || (/^\/collections\//.test(p) && p !== '/collections/all');
    var group = brand ? 'brands' : /^\/pages\/(company|heritage|reviews)$/.test(p) ? 'about' : /^\/pages\/(pictures|videos)$/.test(p) ? 'media' : '';
    var g = group && $('[data-group="' + group + '"]'); if (g) g.setAttribute('data-current', '');
  })();

  /* ---- home slider */
  (function hero() {
    var root = $('#hero'); if (!root) return;
    var slides = $$('.slide', root), dots = $$('.dot', root), pause = $('#hero-pause'), at = 0, timer = null, paused = REDUCED;
    if (slides.length < 2) return;
    function go(i) {
      at = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { var on_ = k === at; s.classList.toggle('on', on_); if (on_) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true'); });
      dots.forEach(function (d, k) { if (k === at) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
    }
    function tick() { clearTimeout(timer); if (!paused && !document.hidden) timer = setTimeout(function () { go(at + 1); tick(); }, 6500); }
    function setPaused(p) {
      paused = p; pause.setAttribute('aria-pressed', String(p));
      $('[data-label]', pause).textContent = p ? 'Play the slideshow' : 'Pause the slideshow';
      tick();
    }
    dots.forEach(function (d) { on(d, 'click', function () { go(+d.getAttribute('data-go')); tick(); }); });
    on(pause, 'click', function () { setPaused(!paused); });
    on(root, 'focusin', function () { clearTimeout(timer); });
    on(root, 'focusout', function () { tick(); });
    on(document, 'visibilitychange', tick);
    setPaused(paused);
  })();

  /* ---- brand gallery */
  (function brandGallery() {
    var root = $('[data-gallery-root]'); if (!root) return;
    var slides = $$('.pg-slide', root), thumbs = $$('.pg-thumb', root), n = $('[data-pg-n]', root), at = 0;
    if (slides.length < 2) return;
    function go(i) {
      at = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.hidden = k !== at; s.classList.toggle('on', k === at); });
      thumbs.forEach(function (t, k) { if (k === at) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
      if (n) n.textContent = at + 1;
    }
    thumbs.forEach(function (t) { on(t, 'click', function () { go(+t.getAttribute('data-go')); }); });
    on($('.pg-prev', root), 'click', function () { go(at - 1); });
    on($('.pg-next', root), 'click', function () { go(at + 1); });
    var stage = $('.pg-stage', root), x0 = null;
    on(stage, 'touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    on(stage, 'touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) go(at + (dx < 0 ? 1 : -1));
    }, { passive: true });
  })();

  /* ---- lightbox */
  (function lightbox() {
    var dlg = $('#lightbox'); if (!dlg || typeof dlg.showModal !== 'function') return;
    var img = $('#lb-img'), cap = $('#lb-cap'), count = $('#lb-count'), list = [], at = 0;
    function show(i) {
      at = (i + list.length) % list.length;
      var a = list[at];
      img.src = a.getAttribute('data-full'); img.alt = a.getAttribute('data-alt');
      img.width = +a.getAttribute('data-w'); img.height = +a.getAttribute('data-h');
      cap.textContent = a.getAttribute('data-alt');
      count.textContent = (at + 1) + ' / ' + list.length;
    }
    on(document, 'click', function (e) {
      var a = e.target.closest('.gal-a'); if (!a) return;
      e.preventDefault();
      list = $$('.gal-a', a.closest('[data-gallery]'));
      show(list.indexOf(a));
      dlg.showModal();
      $('[data-close-lb]', dlg).focus();
    });
    $$('[data-lb]', dlg).forEach(function (b) { on(b, 'click', function () { show(at + (+b.getAttribute('data-lb'))); }); });
    on($('[data-close-lb]', dlg), 'click', function () { dlg.close(); });
    on(dlg, 'click', function (e) { if (e.target === dlg || e.target.classList.contains('lb-in')) dlg.close(); });
    on(dlg, 'keydown', function (e) { if (e.key === 'ArrowRight') show(at + 1); else if (e.key === 'ArrowLeft') show(at - 1); });
    var x0 = null;
    on(dlg, 'touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    on(dlg, 'touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null; if (Math.abs(dx) > 40) show(at + (dx < 0 ? 1 : -1)); }, { passive: true });
  })();

  /* ---- age gate */
  var GATE_KEY = 'fa_age_ok';
  var entered = !document.documentElement.classList.contains('gated');
  var enterQueue = [];
  function whenEntered(fn) { if (entered) fn(); else enterQueue.push(fn); }
  var popupsDone = false, afterPopups = [];
  function whenPopupsDone(fn) { if (popupsDone) fn(); else afterPopups.push(fn); }
  function finishPopups() { if (popupsDone) return; popupsDone = true; afterPopups.splice(0).forEach(function (fn) { fn(); }); }
  function ageFrom(m, d, y) {
    m = +m; d = +d; y = +y;
    var now = new Date();
    if (!(m >= 1 && m <= 12 && d >= 1 && d <= 31 && y >= 1900 && y <= now.getFullYear())) return null;
    var dt = new Date(y, m - 1, d);
    if (dt.getMonth() !== m - 1 || dt.getDate() !== d) return null;
    var age = now.getFullYear() - y;
    if (now.getMonth() + 1 < m || (now.getMonth() + 1 === m && now.getDate() < d)) age--;
    return age;
  }
  (function gate() {
    var g = $('#gate'); if (!g) return;
    var ask = $('#gate-ask'), denied = $('#gate-denied');
    function deny() {
      ask.hidden = true; denied.hidden = false;
      store.sset('fa_age_no', '1');
      denied.focus();
    }
    if (!entered) {
      document.body.classList.add('locked');
      if (store.sget('fa_age_no') === '1') deny();
      else setTimeout(function () { $('#gate-yes').focus(); }, 80);
      on(g, 'keydown', function (e) {
        if (e.key !== 'Tab') return;
        var f = focusables(g), first = f[0], last = f[f.length - 1];
        if (!first) { e.preventDefault(); return; }
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
    }
    on($('#gate-no'), 'click', deny);
    on($('#gate-yes'), 'click', function () {
      if ($('#gate-remember').checked) store.set(GATE_KEY, '1'); else store.sset(GATE_KEY, '1');
      g.classList.add('leaving');
      document.documentElement.classList.remove('gated');
      document.body.classList.remove('locked');
      entered = true;
      setTimeout(function () { g.hidden = true; }, REDUCED ? 0 : 900);
      var main = $('#main'); if (main) main.focus({ preventScroll: true });
      enterQueue.splice(0).forEach(function (fn) { fn(); });
    });
  })();

  /* --------------------------------------------------------------- consent */
  /* The banner records the choice with Shopify's Customer Privacy API, so Shopify and its apps respect it. */
  var CONSENT_KEY = 'fa_consent_v1';
  var consent = null;
  try { consent = JSON.parse(store.get(CONSENT_KEY) || 'null'); } catch (e) { consent = null; }
  var cBox = $('#consent');
  function tellShopify(c) {
    var S = window.Shopify;
    if (!S || typeof S.loadFeatures !== 'function') return;
    S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
      if (err || !S.customerPrivacy) return;
      try { S.customerPrivacy.setTrackingConsent({ analytics: !!c.analytics, marketing: !!c.marketing, preferences: !!c.analytics, sale_of_data: !!c.marketing }, function () {}); } catch (e) { /* older API */ }
    });
  }
  function saveConsent(a, m) {
    if (navigator.globalPrivacyControl) m = false;
    consent = { v: 1, analytics: !!a, marketing: !!m, t: new Date().toISOString().slice(0, 10) };
    store.set(CONSENT_KEY, JSON.stringify(consent));
    if (cBox) cBox.hidden = true;
    tellShopify(consent);
  }
  function showConsent(expand) {
    if (!cBox) return;
    cBox.hidden = false;
    var prefs = $('#consent-prefs'), save = $('[data-consent="save"]', cBox), cust = $('[data-consent="customize"]', cBox);
    if (consent) { $('#consent-analytics').checked = !!consent.analytics; $('#consent-marketing').checked = !!consent.marketing; }
    prefs.hidden = !expand; save.hidden = !expand; cust.setAttribute('aria-expanded', String(!!expand));
    if (expand) $('#consent-analytics').focus();
  }
  if (cBox) {
    on(cBox, 'click', function (e) {
      var b = e.target.closest('[data-consent]'); if (!b) return;
      var k = b.getAttribute('data-consent');
      if (k === 'all') saveConsent(true, true);
      else if (k === 'essential') saveConsent(false, false);
      else if (k === 'customize') showConsent($('#consent-prefs').hidden);
      else if (k === 'save') saveConsent($('#consent-analytics').checked, $('#consent-marketing').checked);
    });
  }
  on(document, 'click', function (e) { if (e.target.closest('[data-consent-open]')) { e.preventDefault(); showConsent(true); } });
  if (!consent && !FA.designMode) whenEntered(function () { whenPopupsDone(function () { setTimeout(function () { showConsent(false); }, 900); }); });

  /* ------------------------------------------------------------ the bag (Shopify cart) */
  var bagEl = $('#bag'), scrim = $('#scrim'), bagBtn = $('#bag-btn');
  var cart = null;
  var BRAND = FA.brandOf || {};
  var ICON_PLUS = '<svg class="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';
  var ICON_MINUS = '<svg class="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M5 12h14"/></svg>';
  function setCount(n) {
    var c = $('#bag-count'); if (!c) return;
    c.textContent = n; c.setAttribute('aria-label', n + (n === 1 ? ' item' : ' items'));
  }
  /* "HEX" reads better in the bag as "EGO White HEX" */
  function itemTitle(i) {
    var b = BRAND[i.handle];
    return b && i.product_title.toLowerCase().indexOf(b.toLowerCase()) !== 0 ? b + ' ' + i.product_title : i.product_title;
  }
  function renderBag() {
    if (!cart) return;
    setCount(cart.item_count);
    var items = $('#bag-items'), sum = $('#bag-sum'), age = $('#bag-age'); if (!items) return;
    if (!cart.items.length) {
      items.innerHTML = '<p class="empty">Your bag is empty.</p>';
      sum.innerHTML = '<a class="btn block" href="' + esc(R.shop || '/collections/all') + '">Explore the collection</a>';
      if (age) age.hidden = true;
      return;
    }
    if (age) age.hidden = false;
    var F = FA.featured;
    items.innerHTML = cart.items.map(function (i) {
      var title = itemTitle(i);
      var detail = [
        i.variant_title && !i.product_has_only_default_variant ? i.variant_title.replace(/ \/ /g, ' · ') : '',
        i.selling_plan_allocation ? i.selling_plan_allocation.selling_plan.name : '',
        F && F.handle === i.handle ? 'Cigar of the month' : ''
      ].filter(Boolean).join(' · ');
      var was = i.original_line_price > i.final_line_price ? '<s class="was">' + money(i.original_line_price / 100) + '</s> ' : '';
      return '<div class="dr-item"><div><h3><a href="' + esc(i.url) + '">' + esc(title) + '</a></h3><p class="d">' + esc(detail) + '</p></div>' +
        '<p class="p">' + was + money(i.final_line_price / 100) + '</p><div class="row"><div class="mini-qty">' +
        '<button type="button" data-k="' + esc(i.key) + '" data-q="' + (i.quantity - 1) + '"><span class="sr-only">One fewer ' + esc(title) + '</span>' + ICON_MINUS + '</button>' +
        '<span aria-label="Quantity">' + i.quantity + '</span>' +
        '<button type="button" data-k="' + esc(i.key) + '" data-q="' + Math.min(20, i.quantity + 1) + '"><span class="sr-only">One more ' + esc(title) + '</span>' + ICON_PLUS + '</button></div>' +
        '<button type="button" class="rm" data-k="' + esc(i.key) + '" data-q="0">Remove</button></div></div>';
    }).join('');
    var total = cart.total_price / 100, fo = (FA.freeOver || 0) / 100;
    var shipLine = fo ? (total >= fo ? 'Complimentary delivery on this order.' : money(fo - total) + ' away from complimentary delivery.') : '';
    var disc = (cart.cart_level_discount_applications || []).map(function (d) { return '<div class="dr-sub dr-disc"><span>' + esc(d.title) + '</span><span>−' + money(d.total_allocated_amount / 100) + '</span></div>'; }).join('');
    sum.innerHTML = disc + '<div class="dr-sub"><span>Subtotal</span><span>' + money(total) + '</span></div>' +
      (shipLine ? '<p class="dr-ship">' + shipLine + '</p>' : '') +
      '<p>Delivery, taxes and discount codes are added at checkout. Every order carries our 30-day money-back guarantee.</p>';
  }
  function loadCart() {
    return api((R.cart || '/cart') + '.js').then(function (c) { cart = c; renderBag(); return c; });
  }
  function openBag(note) {
    $('#bag-note').textContent = note || '';
    if (!openLayers.some(function (l) { return l.el === bagEl; })) openLayer(bagEl, { scrim: scrim, trigger: bagBtn, focus: '[data-close-bag]' });
  }
  function addToBag(variantId, qty, el, extra) {
    if (!variantId) { toast('The price for this size is coming soon.'); return Promise.resolve(); }
    qty = Math.max(1, Math.min(20, parseInt(qty, 10) || 1));
    var item = { id: +variantId, quantity: qty };
    if (extra) for (var k in extra) item[k] = extra[k];
    if (el) { el.setAttribute('aria-busy', 'true'); el.disabled = true; }
    return api((R.cartAdd || '/cart/add') + '.js', { items: [item] }).then(function (res) {
      var it = res.items && res.items[0];
      var feature = $('#feature'); if (feature && feature.open) feature.close();
      return loadCart().then(function () {
        var count = $('#bag-count'); if (count) { count.classList.add('bump'); setTimeout(function () { count.classList.remove('bump'); }, 450); }
        openBag('Added: ' + (it ? itemTitle(it) + (it.product_has_only_default_variant ? '' : ', ' + it.variant_title) : ''));
      });
    }).catch(function (err) {
      toast((err && (err.description || err.message)) || 'That could not be added just now. Please try again.');
    }).then(function () { if (el) { el.removeAttribute('aria-busy'); el.disabled = false; } });
  }
  on(bagBtn, 'click', function () { openBag(''); loadCart(); });
  on(scrim, 'click', function () { closeLayer(bagEl); });
  $$('[data-close-bag]').forEach(function (b) { on(b, 'click', function () { closeLayer(bagEl); }); });
  on($('#bag-items'), 'click', function (e) {
    var b = e.target.closest('button[data-k]'); if (!b) return;
    var key = b.getAttribute('data-k'), q = +b.getAttribute('data-q'), cls = b.className;
    api((R.cartChange || '/cart/change') + '.js', { id: key, quantity: q }).then(function (c) {
      cart = c; renderBag();
      var again = $('button[data-k="' + CSS.escape(key) + '"]' + (cls ? '.' + cls : ':not(.rm)'), $('#bag-items'));
      (again || $('[data-close-bag]')).focus();
    }).catch(function () { toast('The bag could not be updated. Please try again.'); });
  });
  on(document, 'click', function (e) {
    var b = e.target.closest('[data-add]'); if (!b || b.closest('form#configurator')) return;
    e.preventDefault();
    if (b.disabled || !b.getAttribute('data-variant')) { toast('The price for this size is coming soon.'); return; }
    addToBag(b.getAttribute('data-variant'), 1, b);
  });
  setCount(FA.cartCount || 0);

  /* ------------------------------ welcome pop-ups: the letter (10% off), then the cigar of the month */
  (function popups() {
    var nl = $('#nl-pop'), fe = $('#feature'), F = FA.featured, bc = document.body.classList;
    $$('[data-close-dialog]').forEach(function (x) { on(x, 'click', function () { var d = x.closest('dialog'); if (d && d.open) d.close(); }); });
    [nl, fe].forEach(function (d) { on(d, 'click', function (e) { if (e.target === d) d.close(); }); });
    var canModal = !!(nl && typeof nl.showModal === 'function');
    // returning from a newsletter sign-up: Shopify reloads the page with ?customer_posted=true#<form id>
    var postedId = QS.customer_posted === 'true' ? (location.hash || '').slice(1) : '';
    if (QS.customer_posted === 'true') store.set('fa_nl_done', '1');
    var postedPopup = canModal && postedId === 'nl-pop-form';
    if (QS.customer_posted === 'true' && !postedPopup) {
      var f = postedId && document.getElementById(postedId), msg = f && $('.form-msg', f);
      if (msg && !msg.classList.contains('err')) { msg.textContent = 'Welcome to the family. Check your inbox: your 10% code arrives with your welcome letter.'; msg.className = 'form-msg ok'; }
      else if (!f) toast('Welcome to the family. Your 10% code arrives with your welcome letter.');
    }
    var quiet = FA.designMode || ['page-checkout', 'page-legal', 'page-404', 'page-narrow', 'page-club'].some(function (c) { return bc.contains(c); });
    var nlSeen = +(store.get('fa_nl_seen') || 0);
    var wantNl = postedPopup || (!quiet && canModal && FA.newsletterPopup !== false && store.get('fa_nl_done') !== '1' && Date.now() - nlSeen > 30 * 864e5);
    var wantFe = !quiet && canModal && !!fe && !!F && F.popup !== false && store.get('fa_feature_seen') !== F.id;
    var gateWasUp = !entered;
    if (!wantNl && !wantFe) { whenEntered(finishPopups); return; }
    function open(dlg, done) {
      // wait while the bag or the menu is open, or the tab is in the background
      if (openLayers.length || document.hidden) { setTimeout(function () { open(dlg, done); }, 1500); return; }
      var img = $('.feature-img', dlg); if (img) img.loading = 'eager';
      on(dlg, 'close', function once() { dlg.removeEventListener('close', once); done(); });
      dlg.showModal();
    }
    function feature() {
      if (!wantFe) { finishPopups(); return; }
      store.set('fa_feature_seen', F.id);
      open(fe, finishPopups);
    }
    function letter() {
      store.set('fa_nl_seen', String(Date.now()));
      if (postedPopup) {
        var body = $('.nl-body', nl), done = $('.nl-done', nl), err = $('.form-msg.err', nl);
        if (!err) {
          $('p', done).textContent = 'Welcome to the family. Check your inbox: your 10% code arrives with your welcome letter.';
          body.hidden = true; done.hidden = false;
        }
      }
      open(nl, function () { setTimeout(feature, REDUCED ? 200 : 1200); });
    }
    whenEntered(function () { setTimeout(wantNl ? letter : feature, postedPopup ? 300 : gateWasUp ? 1100 : 2500); });
  })();

  /* ---- form helpers */
  var MESSAGES = {
    email: 'Enter a valid email address, like name@example.com.',
    zip: 'Enter a 5-digit ZIP code.',
    state: 'Choose your state.',
    tel: 'Enter a phone number the carrier can call.',
    checkbox: 'Please tick the box to continue.',
    radio: 'Please choose an option.',
    'default': 'Complete the highlighted field.'
  };
  function fieldLabel(f) {
    var l = f.id && $('label[for="' + f.id + '"]');
    return l ? l.textContent.replace(/\(optional\)/i, '').trim() : '';
  }
  function fieldMessage(f) {
    if (f.type === 'email') return MESSAGES.email;
    if (f.name === 'zip') return MESSAGES.zip;
    if (f.name === 'state') return MESSAGES.state;
    if (f.type === 'tel') return MESSAGES.tel;
    if (f.type === 'checkbox') return MESSAGES.checkbox;
    if (f.type === 'radio') return MESSAGES.radio;
    var l = fieldLabel(f);
    return l ? 'Enter your ' + l.toLowerCase() + '.' : MESSAGES['default'];
  }
  function validate(form, msgEl) {
    var fields = $$('input, select, textarea', form).filter(function (f) { return !f.closest('[hidden]') && !f.classList.contains('hp') && f.type !== 'hidden'; });
    fields.forEach(function (f) { f.classList.add('touched'); f.removeAttribute('aria-invalid'); });
    var bad = fields.filter(function (f) { return !f.checkValidity(); });
    bad.forEach(function (f) { f.setAttribute('aria-invalid', 'true'); });
    if (bad.length) {
      say(msgEl, fieldMessage(bad[0]), true);
      bad[0].focus();
      return false;
    }
    return true;
  }
  function say(el, text, bad) { if (!el) return; el.textContent = text; el.className = 'form-msg ' + (bad ? 'err' : 'ok'); }
  function busy(btn, yes) { if (!btn) return; btn.setAttribute('aria-busy', yes ? 'true' : 'false'); btn.disabled = !!yes; }
  function honeypot(form) { var h = $('.hp', form); return h && h.value; }
  function data(form) { var o = {}; new FormData(form).forEach(function (v, k) { o[k] = typeof v === 'string' ? v.trim() : v; }); return o; }
  $$('form').forEach(function (f) { on(f, 'input', function (e) { if (e.target.classList.contains('touched')) e.target.removeAttribute('aria-invalid'); }); });

  /* ------------------------------------------------------------ newsletter */
  $$('form.fa-nl').forEach(function (form) {
    var tags = $('[data-tags]', form), alloc = $('[data-alloc]', form);
    if (alloc && tags) on(alloc, 'change', function () { tags.value = alloc.checked ? 'newsletter,ego-black-allocation' : 'newsletter'; });
    on(form, 'submit', function (e) {
      var msg = $('.form-msg', form);
      if (!validate(form, msg)) { e.preventDefault(); return; }
      if (!tags || /newsletter/.test(tags.value)) store.set('fa_nl_done', '1');
      var btn = $('button[type="submit"]', form); if (btn) btn.setAttribute('aria-busy', 'true');
    });
  });

  /* --------------------------------------------------------------- enquiry */
  (function enquiry() {
    var form = $('#enquiry-form'); if (!form) return;
    var done = $('#enq-done'); if (done) { done.focus(); return; }
    var topic = $('#e-topic'), msgBox = $('#e-msg');
    function pick(t) { var o = topic && $('option[data-topic="' + t + '"]', topic); if (o) topic.value = o.value; }
    if (QS.topic) pick(QS.topic);
    if (QS.subject && msgBox && !msgBox.value) { pick('pricing'); msgBox.value = 'I would like pricing and availability for: ' + QS.subject + '.'; }
    if (QS.topic === 'review' && msgBox) msgBox.placeholder = 'Which cigar did you smoke, and what did you think?';
    on(form, 'submit', function (e) { if (!validate(form, $('.form-msg', form))) e.preventDefault(); });
  })();

  /* ---- collection */
  (function filters() {
    var grid = $('#coll-grid'); if (!grid) return;
    var state = { strength: 'all', format: 'all' };
    function apply() {
      var shown = 0;
      $$('.sc', grid).forEach(function (c) {
        var okS = state.strength === 'all' || (' ' + c.getAttribute('data-strength') + ' ').indexOf(' ' + state.strength + ' ') > -1;
        var okF = state.format === 'all' || c.getAttribute('data-format') === state.format;
        c.hidden = !(okS && okF); if (okS && okF) shown++;
      });
      $('#filter-count').textContent = shown === 0 ? 'No brands match. Try another filter.' : shown + (shown === 1 ? ' brand' : ' brands');
    }
    $$('[data-filter-group]').forEach(function (g) {
      on(g, 'click', function (e) {
        var b = e.target.closest('[data-filter]'); if (!b) return;
        $$('[data-filter]', g).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        state[g.getAttribute('data-filter-group')] = b.getAttribute('data-filter');
        apply();
      });
    });
    apply();
  })();

  /* --------------------------------------------------------------- brand page */
  /* Every size of the brand is a product in the store (sizes-json); choosing a size, a wrapper (CSB) and a box
     picks that product's variant, read live. A size's own address (/products/hex) opens with it selected. */
  function setGauge(root, body) {
    var n = $('.g-needle', root), a = $('.g-arc', root);
    if (n) n.style.transform = 'rotate(' + ((body - 0.5) * 180).toFixed(1) + 'deg)';
    if (a) a.style.strokeDasharray = (body * 100).toFixed(1) + ' 100';
  }
  (function product() {
    var form = $('#configurator'); if (!form) return;
    var SJ = {};
    try { SJ = JSON.parse($('#sizes-json').textContent) || {}; } catch (e) { SJ = {}; }
    var wrappers = JSON.parse(form.getAttribute('data-wrappers') || '{}');
    var gauge = $('.p-gauge'), idIn = $('#variant-id'), addBtn = $('#add-btn');
    var WRAP_RE = /\s*-\s*(Habano|Connecticut|Maduro)\s*$/i;
    function cur() {
      var v = $('input[name="vitola"]:checked', form) || $('input[name="vitola"]', form);
      var w = $('input[name="wrapper"]:checked', form);
      var f = $('input[name="format"]:checked', form);
      return { v: v, vid: v.value, w: w, wid: w ? w.value : Object.keys(wrappers)[0], f: f };
    }
    function boxLabel(t) { return t === 'Default Title' ? 'Box' : t.replace(WRAP_RE, ''); }
    function variantsFor(c) {
      var P = SJ[c.vid]; if (!P || !P.variants) return [];
      var key = c.w ? c.w.getAttribute('data-key') : null;
      var vs = P.variants, only = (FA.boxes || {})[P.handle];
      if (only) vs = vs.filter(function (v) { return only.indexOf(v.title) > -1; });
      if (key && vs.some(function (v) { return WRAP_RE.test(v.title); })) {
        vs = vs.filter(function (v) { return v.title.toLowerCase().indexOf(key.toLowerCase()) > -1; });
      }
      return vs;
    }
    function renderFormats() {
      var c = cur(), vs = variantsFor(c);
      var seg = $('#format-seg'), fs = seg.closest('fieldset');
      var keep = c.f ? c.f.getAttribute('data-label') : null;
      var labels = vs.map(function (v) { return boxLabel(v.title); });
      var pick = keep && labels.indexOf(keep) > -1 ? keep : labels[0];
      seg.innerHTML = vs.map(function (v, i) {
        return '<label><input type="radio" name="format" value="' + v.id + '" data-label="' + esc(labels[i]) + '"' + (labels[i] === pick ? ' checked' : '') + '><span>' + esc(labels[i]) + '</span></label>';
      }).join('');
      fs.hidden = vs.length < 2;
    }
    function selected() {
      var c = cur(), vs = variantsFor(c), f = $('input[name="format"]:checked', form), id = f ? +f.value : null;
      return vs.filter(function (v) { return v.id === id; })[0] || vs[0] || null;
    }
    function update(animate) {
      var c = cur(), vEl = c.v, P = SJ[c.vid];
      $$('.ps-variant').forEach(function (s) {
        var match = s.getAttribute('data-v') === c.vid && s.getAttribute('data-w') === c.wid;
        s.hidden = !match; s.classList.toggle('on', match);
      });
      var v = selected();
      $('#sel-name').textContent = vEl.getAttribute('data-name') || '';
      var dims = vEl.getAttribute('data-dims'), mins = vEl.getAttribute('data-mins'), vit = vEl.getAttribute('data-vitola');
      $('#sel-sub').textContent = [dims, vit, mins ? 'about ' + mins + ' minutes' : ''].filter(Boolean).join(' · ');
      var w = wrappers[c.wid];
      if (w) { $('#body-label').textContent = w.label; if (gauge) setGauge(gauge, w.body); }
      var price = v && v.price > 0 ? v.price / 100 : null;
      var was = v && v.compare_at_price > v.price ? v.compare_at_price / 100 : null;
      var none = !v && P && c.w && P.variants && P.variants.length;
      $('#p-price').innerHTML = none ? '<span class="soon">Made in the other wrapper</span>' : price == null ? '<span class="soon">Price coming soon</span>' : (was ? '<s class="was">' + money(was) + '</s> ' : '') + money(price);
      var label = v ? boxLabel(v.title) : 'box';
      $('#p-unit').textContent = label.toLowerCase();
      $('#p-unit').parentNode.hidden = price == null;
      var count = /(\d+)/.exec(label);
      var each = $('#p-each'); if (each) each.textContent = price != null && count && +count[1] > 1 ? money(price / +count[1]) + ' a cigar' : '';
      var sale = $('#p-sale');
      if (sale) {
        var F = FA.featured, pct = was ? Math.round((was - price) / was * 100) : 0;
        sale.hidden = !pct;
        if (pct) sale.textContent = (F && P && F.handle === P.handle ? 'Cigar of the month: ' : 'Now ') + pct + '% off, already in the price.';
      }
      idIn.value = v ? v.id : '';
      addBtn.disabled = !v || price == null || !v.available;
      addBtn.textContent = !P ? 'Price coming soon' : none ? 'Not in this wrapper' : price == null ? 'Price coming soon' : (!v.available ? 'Sold out' : 'Add to bag');
      if (animate !== false && window.history && history.replaceState && P) {
        var path = '/products/' + P.handle;
        var q = Object.keys(wrappers).length > 1 ? '?wrapper=' + c.wid : '';
        if (location.pathname.indexOf('/products/') === 0) history.replaceState(null, '', path + q);
      }
    }
    function showWrapperPhoto(wid) {
      var t = $('.pg-thumb[data-wrapper="' + CSS.escape(wid) + '"]') || ($('.pg-thumb[data-wrapper]') && $('.pg-thumb'));
      if (t) t.click();
    }
    var want = form.getAttribute('data-selected') || QS.size;
    if (want) {
      var s = $$('input[name="vitola"]', form).filter(function (x) { return x.value === want || x.getAttribute('data-handle') === want || handleize(x.getAttribute('data-name')) === handleize(want); })[0];
      if (s) s.checked = true;
    }
    if (QS.wrapper) { var ww = $('input[name="wrapper"][value="' + CSS.escape(QS.wrapper) + '"]', form); if (ww) ww.checked = true; }
    renderFormats();
    on(form, 'change', function (e) {
      if (e.target.name === 'qty') return;
      if (e.target.name === 'vitola' || e.target.name === 'wrapper') renderFormats();
      if (e.target.name === 'wrapper') showWrapperPhoto(e.target.value);
      update(true);
    });
    if (QS.wrapper && Object.keys(wrappers).length > 1) setTimeout(function () { showWrapperPhoto(cur().wid); }, 0);
    var qty = $('#qty');
    $$('.qty-b', form).forEach(function (b) {
      on(b, 'click', function () { qty.value = Math.max(1, Math.min(20, (parseInt(qty.value, 10) || 1) + (+b.getAttribute('data-qty')))); });
    });
    on(qty, 'change', function () { qty.value = Math.max(1, Math.min(20, parseInt(qty.value, 10) || 1)); });
    on(form, 'submit', function (e) {
      e.preventDefault();
      if (!idIn.value) { toast('The price for this size is coming soon.'); return; }
      addToBag(idIn.value, qty.value, addBtn);
    });
    if (gauge) setGauge(gauge, 0);
    setTimeout(function () { update(false); }, 60);
  })();

  /* other products (Legends, VFL, tasters…): the price follows the chosen option; Add to bag opens the bag */
  (function generic() {
    var form = $('#generic-product-form'); if (!form) return;
    var P = null; try { P = JSON.parse($('#generic-json').textContent); } catch (e) { return; }
    var sel = $('#g-variant');
    on(sel, 'change', function () {
      var v = P.variants.filter(function (x) { return String(x.id) === sel.value; })[0]; if (!v) return;
      $('#g-price').innerHTML = v.price > 0 ? (v.compare_at_price > v.price ? '<s class="was">' + money(v.compare_at_price / 100) + '</s> ' : '') + money(v.price / 100) : '<span class="soon">Price coming soon</span>';
    });
    on(form, 'submit', function (e) {
      if ($('input[name="selling_plan"]:checked', form) && $('input[name="selling_plan"]:checked', form).value) return; // subscriptions go through Shopify's own form
      e.preventDefault();
      var id = sel ? sel.value : $('input[name="id"]', form).value;
      addToBag(id, $('input[name="quantity"]', form).value, $('[data-generic-add]', form));
    });
  })();

  (function share() {
    var box = $('[data-share]'); if (!box) return;
    var canon = $('link[rel="canonical"]');
    var href = canon ? canon.href : location.href.split('?')[0];
    var title = box.getAttribute('data-title') || document.title;
    var u = encodeURIComponent(href), t = encodeURIComponent(title);
    var links = {
      x: 'https://twitter.com/intent/tweet?text=' + t + '&url=' + u,
      facebook: 'https://www.facebook.com/sharer/sharer.php?u=' + u,
      whatsapp: 'https://wa.me/?text=' + t + '%20' + u,
      email: 'mailto:?subject=' + t + '&body=' + t + '%0A%0A' + u
    };
    $$('[data-share-to]', box).forEach(function (a) { a.href = links[a.getAttribute('data-share-to')]; });
    var nat = $('[data-share-native]', box);
    if (navigator.share && nat) { nat.hidden = false; on(nat, 'click', function () { navigator.share({ title: title, url: href }).catch(function () { /* dismissed */ }); }); }
    on($('[data-share-copy]', box), 'click', function () {
      var done = function () { toast('Link copied.'); };
      if (navigator.clipboard) navigator.clipboard.writeText(href).then(done, function () { toast(href); });
      else toast(href);
    });
  })();

  /* ---- home dial */
  (function dial() {
    var ctl = $('#dial-ctl'); if (!ctl) return;
    var stages = $$('.dial-stage'), picks = $$('.dial-pick'), stops = $$('.d-stop'), nums = $$('.d-num');
    var needle = $('.dial-needle', ctl), track_ = $('.dial-track', ctl);
    var n = stages.length, idx = +ctl.getAttribute('aria-valuenow');
    var angles = stages.map(function (s) { return +s.getAttribute('data-angle'); });
    var START = angles[0], SWEEP = angles[n - 1] - angles[0];
    function needleTo(angle, instant) {
      needle.style.transition = instant ? 'none' : '';
      needle.style.transform = 'rotate(' + angle + 'deg)';
      track_.style.transition = instant ? 'none' : '';
      track_.style.strokeDasharray = (((angle - START) / SWEEP) * 100).toFixed(2) + ' 100';
    }
    function set(i, opts) {
      opts = opts || {};
      i = Math.max(0, Math.min(n - 1, i));
      var changed = i !== idx; idx = i;
      if (!opts.keepNeedle) needleTo(angles[i], opts.instant);
      stages.forEach(function (s, k) { var on_ = k === i; s.hidden = !on_; s.classList.toggle('on', on_); });
      picks.forEach(function (p, k) { p.setAttribute('aria-pressed', String(k === i)); });
      stops.forEach(function (s, k) { s.classList.toggle('on', k === i); });
      nums.forEach(function (s, k) { s.classList.toggle('on', k === i); });
      var name = $('.dial-name', stages[i]).textContent, body = $('.dial-meta span', stages[i]).textContent;
      ctl.setAttribute('aria-valuenow', i);
      ctl.setAttribute('aria-valuetext', name + ', ' + body);
      if (changed && opts.user) track('select_content', { content_type: 'strength_dial', item_id: name });
    }
    picks.forEach(function (p, k) { on(p, 'click', function () { set(k, { user: true }); }); });
    on(ctl, 'keydown', function (e) {
      var k = e.key, i = idx;
      if (k === 'ArrowRight' || k === 'ArrowUp') i++;
      else if (k === 'ArrowLeft' || k === 'ArrowDown') i--;
      else if (k === 'Home') i = 0;
      else if (k === 'End') i = n - 1;
      else if (k === 'PageUp') i += 2;
      else if (k === 'PageDown') i -= 2;
      else return;
      e.preventDefault(); set(i, { user: true });
    });
    var dragging = false;
    function angleOf(e) {
      var r = ctl.getBoundingClientRect();
      var dx = e.clientX - (r.left + r.width / 2), dy = e.clientY - (r.top + r.height / 2);
      var a = Math.atan2(dx, -dy) * 180 / Math.PI;
      return Math.max(START, Math.min(START + SWEEP, a));
    }
    function nearest(a) { return Math.round((a - START) / SWEEP * (n - 1)); }
    on(ctl, 'pointerdown', function (e) {
      dragging = true; ctl.setPointerCapture(e.pointerId); ctl.focus({ preventScroll: true });
      var a = angleOf(e); needleTo(a, true); set(nearest(a), { keepNeedle: true, user: true });
    });
    on(ctl, 'pointermove', function (e) {
      if (!dragging) return;
      var a = angleOf(e); needleTo(a, true);
      var i = nearest(a); if (i !== idx) set(i, { keepNeedle: true, user: true });
    });
    function end() { if (!dragging) return; dragging = false; set(idx); }
    on(ctl, 'pointerup', end); on(ctl, 'pointercancel', end);
    // sweep once into view: from the mildest stop to the house default
    var target = idx;
    if (REDUCED || !('IntersectionObserver' in window)) { set(target, { instant: true }); return; }
    set(0, { instant: true });
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (en.isIntersecting) { io.disconnect(); whenEntered(function () { setTimeout(function () { set(target); }, 250); }); }
      });
    }, { threshold: .45 });
    io.observe(ctl);
  })();

  /* ---- home tray */
  (function tray() {
    var tabs = $$('.tray-tab'); if (!tabs.length) return;
    function select(t, focus) {
      tabs.forEach(function (x) {
        var on_ = x === t;
        x.setAttribute('aria-selected', String(on_)); x.tabIndex = on_ ? 0 : -1;
        document.getElementById(x.getAttribute('aria-controls')).hidden = !on_;
      });
      if (focus) t.focus();
      var bar = t.parentNode, left = t.offsetLeft - bar.offsetLeft;
      if (left < bar.scrollLeft || left + t.offsetWidth > bar.scrollLeft + bar.clientWidth) bar.scrollTo({ left: left - 24, behavior: REDUCED ? 'auto' : 'smooth' });
      track('select_content', { content_type: 'size_tray', item_id: t.id.replace('tt-', '') });
    }
    tabs.forEach(function (t, i) {
      on(t, 'click', function () { select(t); });
      on(t, 'keydown', function (e) {
        var j = i;
        if (e.key === 'ArrowRight') j = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') j = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') j = 0;
        else if (e.key === 'End') j = tabs.length - 1;
        else return;
        e.preventDefault(); select(tabs[j], true);
      });
    });
  })();

  /* ---- finder */
  (function finder() {
    var form = $('#finder'); if (!form) return;
    var steps = $$('.fq', form), bars = $$('.fq-progress li', form), back = $('[data-fq-back]'), nEl = $('[data-fq-n]');
    var result = $('#finder-result'), at = 0;
    function go(i) {
      at = i;
      steps.forEach(function (s, k) { s.hidden = k !== i; s.classList.toggle('on', k === i); });
      bars.forEach(function (b, k) { b.classList.toggle('on', k <= i); });
      back.hidden = i === 0; nEl.textContent = i + 1;
    }
    on(form, 'change', function (e) {
      if (e.target.type !== 'radio') return;
      setTimeout(function () {
        if (at < steps.length - 1) { go(at + 1); var f = $('input', steps[at]); if (f) f.focus(); }
        else finish();
      }, REDUCED ? 0 : 260);
    });
    on(back, 'click', function () { if (at > 0) go(at - 1); });
    on($('[data-fq-restart]'), 'click', function () { form.reset(); result.hidden = true; form.hidden = false; go(0); $('input', steps[0]).focus(); });
    function finish() {
      var a = data(form);
      var target = parseFloat(a.strength || '0.7');
      var when = a.when, time = a.time, drink = a.drink;
      if (when === 'morning') target -= 0.12; else if (when === 'evening') target += 0.05;
      var cards = $$('.fr-card', result).map(function (c) {
        var line = c.getAttribute('data-line'), wr = c.getAttribute('data-wrapper'), body = +c.getAttribute('data-body');
        var s = -Math.abs(body - target) * 3, why = [];
        if (drink === 'coffee' && (wr === 'connecticut' || line === 'havana-sunrise-reserve')) { s += .5; why.push(wr === 'connecticut' ? 'Its Connecticut wrapper is made for the first coffee of the day.' : 'Creamy and medium-bodied, it sits easily beside a morning coffee.'); }
        if (drink === 'coffee' && (line === 'csb-fuerte' || line === 'ego-gold') && target > .7) { s += .35; why.push('Felix blends it to pair with a strong, dark coffee.'); }
        if (drink === 'beer' && (line === 'something-special' || line === 'ringo' || wr === 'habano')) { s += .45; why.push('Medium to full and easygoing: right for something cold and crisp.'); }
        if (drink === 'spirits' && (line === 'ego-black' || line === 'csb-fuerte' || line === 'ii-saints' || line === 'ego-red')) { s += .45; why.push(line === 'ii-saints' ? 'Puro Maduro paired it with Octomore, a heavily peated Scotch.' : 'It has the weight to stand up to a rum, a whisky or a bourbon.'); }
        if (drink === 'wine' && (line === 'ego-gold' || line === 'ego-white' || line === 'ii-saints-platinum')) { s += .55; why.push(line === 'ego-gold' ? 'Ninety-six points from Stogie Press, and blended for dark wines and peaty Scotches.' : 'Full and clean-finishing, with the depth for a big red or a peated Scotch.'); }
        if (when === 'afternoon' && (line === 'ego-ocean-blue' || line === 'something-special')) { s += .35; why.push(line === 'ego-ocean-blue' ? 'Full-bodied without the heaviness, as Bill Bennett put it: an anytime stick.' : 'A medium-to-full everyday cigar, at an everyday price.'); }
        if (when === 'evening' && (line === 'ego-black' || line === 'ego-ocean-blue')) { s += .3; if (!why.length) why.push(line === 'ego-black' ? 'Single-farm and aged six years: a cigar for an unhurried evening.' : 'The one you want after a big meal, to round out a perfect evening.'); }
        if (when === 'celebration' && (line === 'ego-gold' || line === 'ego-black' || line === 'ii-saints-platinum')) { s += .35; if (!why.length) why.push('Among the house’s most celebrated cigars, for the moments worth marking.'); }
        if (time === 'short' && (line === 'csb' || line === 'havana-sunrise-reserve' || line === 'ringo')) s += .12;
        if (time === 'long' && (line === 'ego-gold' || line === 'ego-ocean-blue' || line === 'ii-saints-platinum')) s += .12;
        if (!why.length) why.push(body < .5 ? 'Mild and smooth, with the flavor held all the way through.' : body < .8 ? 'Medium to full: flavor first, with strength to match.' : 'Full-bodied and bold, from first light to the final draw.');
        return { el: c, score: s, why: why[0] };
      }).sort(function (x, y) { return y.score - x.score; });
      cards.forEach(function (c, i) {
        c.el.hidden = i > 2; c.el.classList.toggle('alt', i > 0);
        $('.fr-why', c.el).textContent = i === 0 ? c.why : '';
        c.el.parentNode.appendChild(c.el);
      });
      form.hidden = true; result.hidden = false; result.focus();
      track('select_content', { content_type: 'cigar_finder', item_id: cards[0].el.getAttribute('data-line') });
    }
    go(0);
  })();

  /* --------------------------------------------------------------- society */
  /* Joining adds the chosen tier to the bag on its subscription plan (Shopify Subscriptions); renewals,
     skips and cancellations are handled by Shopify from the member's account. */
  (function society() {
    var view = $$('[data-cadence-view]');
    var box = $('#club-join');
    function sync() {
      if (!box) return;
      var t = $('input[name="tier"]:checked', box), c = $('input[name="cadence"]:checked', box);
      if (t) $$('[data-renew-amount]').forEach(function (x) { x.textContent = +t.getAttribute('data-price') > 0 ? money(+t.getAttribute('data-price') / 100) : 'the tier price'; });
      if (c) $$('[data-renew-cadence]').forEach(function (x) { x.textContent = c.getAttribute('data-label').toLowerCase(); });
    }
    view.forEach(function (b) {
      on(b, 'click', function () {
        view.forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        $$('.tp-unit').forEach(function (u) { u.textContent = 'per delivery, ' + b.textContent.toLowerCase(); });
        var r = box && $('input[name="cadence"][value="' + b.getAttribute('data-cadence-view') + '"]', box); if (r) { r.checked = true; sync(); }
      });
    });
    if (!box) return;
    if (QS.tier) { var t = $$('input[name="tier"]', box).filter(function (x) { return handleize(x.value) === handleize(QS.tier); })[0]; if (t) t.checked = true; }
    on(box, 'change', sync); sync();
    var msg = $('.form-msg', box), btn = $('#club-join-btn');
    var PLAN = { monthly: /(^|[^0-9])1\s*(month|mo)|every month|monthly/i, bimonthly: /2\s*(months|mo)|two months|bi-?monthly/i };
    on(btn, 'click', function () {
      var tier = $('input[name="tier"]:checked', box), cad = $('input[name="cadence"]:checked', box);
      if (!tier || !cad) { say(msg, 'Choose a tier and a delivery rhythm.', true); return; }
      if (!$('#renew-ok').checked) { say(msg, 'Please agree to the automatic renewal terms.', true); $('#renew-ok').focus(); return; }
      if (!$('#club-age').checked) { say(msg, 'Please confirm you are 21 or older.', true); $('#club-age').focus(); return; }
      busy(btn, true); say(msg, '');
      api('/products/' + encodeURIComponent(FA.society || 'jamastran-society') + '.js').then(function (p) {
        var v = p.variants.filter(function (x) { return x.option1 === tier.value || x.title === tier.value; })[0];
        if (!v) throw new Error('tier');
        var allowed = (v.selling_plan_allocations || []).map(function (a) { return a.selling_plan_id; });
        var plans = [];
        (p.selling_plan_groups || []).forEach(function (g) { (g.selling_plans || []).forEach(function (sp) { plans.push(sp); }); });
        var re = PLAN[cad.value];
        var plan = plans.filter(function (sp) {
          var text = sp.name + ' ' + (sp.options || []).map(function (o) { return o.value; }).join(' ');
          return re.test(text) && (!allowed.length || allowed.indexOf(sp.id) > -1);
        })[0];
        if (!plan) throw new Error('plan');
        busy(btn, false);
        return addToBag(v.id, 1, btn, { selling_plan: plan.id });
      }).catch(function (err) {
        busy(btn, false);
        say(msg, err && (err.message === 'plan' || err.message === 'tier' || err.status === 404)
          ? 'Memberships open very soon. Write to us and we will enrol you directly.'
          : 'We could not start your membership just now. Please try again, or write to us.', true);
      });
    });
  })();

  /* ---------------------------------------------------------------- search */
  /* The header's search panel and the search page. Brands, sizes and pages come from the theme, products and their
     live prices from the store, in one request (/search?view=fa-index) kept for the visit. In this store a product is
     one size ("HEX"), so each is indexed with its brand and dimensions: "EGO White", "toro" or "6x54" all find it. */
  (function search() {
    var dlg = $('#srch'), btn = $('#srch-btn'), page = $('#search-app');
    if (!dlg && !page) return;
    var KEY = 'fa_search_v1', INDEX = null, loading = null;

    function fold(s) {
      return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
        .replace(/(\d)\s*½/g, '$1.5').replace(/½/g, '.5').replace(/×/g, 'x').replace(/(\d)\s*x\s*(\d)/g, '$1x$2')
        .replace(/[^a-z0-9.%]+/g, ' ').trim();
    }
    function doc(kind, name, sub, url, img, price, extra, avail) {
      var nameF = fold(name);
      return { kind: kind, name: name, sub: sub || '', url: url, img: img || '', price: price || '', avail: avail !== false,
        nameF: nameF, words: (nameF + ' ' + fold(sub) + ' ' + fold(extra)).split(' ').filter(Boolean) };
    }
    function build(j) {
      var docs = [], meta = j.meta || {}, brandOf = FA.brandOf || {};
      (j.brands || []).forEach(function (b) { docs.push(doc('brand', b.n, b.s, b.u, b.img, '', b.k)); });
      (j.products || []).forEach(function (p) {
        var m = meta[p.h] || {}, brand = m.b || brandOf[p.h] || '';
        var title = m.n || p.t, name = brand && title.toLowerCase().indexOf(brand.toLowerCase()) !== 0 ? brand + ' ' + title : title;
        docs.push(doc('product', name, m.s || p.ty || '', (R.root || '/') + 'products/' + p.h, p.img, p.pr, [p.t, m.k, p.ty, p.tg].join(' '), p.a));
      });
      (j.pages || []).forEach(function (pg) { docs.push(doc('page', pg.n, '', pg.u, '', '', pg.k)); });
      return docs;
    }
    function load() {
      if (INDEX) return Promise.resolve(INDEX);
      if (loading) return loading;
      var cached = store.sget(KEY);
      if (cached) { try { INDEX = build(JSON.parse(cached)); return Promise.resolve(INDEX); } catch (e) { /* rebuild below */ } }
      loading = fetch((R.search || '/search') + '?view=fa-index', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('index'); return r.text(); })
        .then(function (t) { INDEX = build(JSON.parse(t)); store.sset(KEY, t); return INDEX; })
        .catch(function (e) { loading = null; throw e; });
      return loading;
    }

    /* every word typed must start a word of the entry (or, from three letters, appear inside one);
       plurals count as the singular ("shots" finds Shot) and little words ("the", "of") are ignored */
    var STOP = { the: 1, a: 1, an: 1, of: 1, and: 1, in: 1, with: 1, for: 1, by: 1 };
    function forms(t) {
      var f = [t];
      if (t.length > 3 && /s$/.test(t)) f.push(t.slice(0, -1));
      if (t.length > 4 && /es$/.test(t)) f.push(t.slice(0, -2));
      return f;
    }
    function find(q, docs) {
      var qf = fold(q), toks = qf.split(' ').filter(function (t) { return t && !STOP[t]; });
      if (!toks.length) toks = qf.split(' ').filter(Boolean);
      if (!toks.length) return [];
      var hits = [];
      docs.forEach(function (d) {
        var score = 0;
        for (var i = 0; i < toks.length; i++) {
          var fs = forms(toks[i]), best = 0;
          for (var k = 0; k < d.words.length && best < 3; k++) {
            var w = d.words[k];
            for (var j = 0; j < fs.length; j++) {
              var t = fs[j];
              if (w === t) { best = 3; break; }
              if (w.indexOf(t) === 0) best = Math.max(best, 2);
              else if (t.length > 2 && w.indexOf(t) > 0) best = Math.max(best, 1);
            }
          }
          if (!best) return;
          score += best + (d.nameF.split(' ').some(function (w) { return fs.some(function (t) { return w.indexOf(t) === 0; }); }) ? 2 : 0);
        }
        if (d.nameF.indexOf(qf) === 0) score += 4;
        if (d.kind === 'brand') score += 2;
        if (d.kind === 'product' && !d.avail) score -= 1;
        hits.push({ d: d, s: score });
      });
      hits.sort(function (a, b) { return b.s - a.s || a.d.name.localeCompare(b.d.name); });
      return hits.map(function (h) { return h.d; });
    }

    function mark(text, q) {
      var toks = [];
      fold(q).split(' ').forEach(function (t) { if (t && !STOP[t]) toks = toks.concat(forms(t)); });
      return text.split(/(\s+)/).map(function (w) {
        var f = fold(w);
        return f && toks.some(function (t) { return f.indexOf(t) === 0; }) ? '<mark>' + esc(w) + '</mark>' : esc(w);
      }).join('');
    }
    function item(d, q) {
      var thumb = d.img ? '<img src="' + esc(d.img) + '" alt="" loading="lazy" width="56" height="56">'
        : '<svg class="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6"/><path d="M15 15l5 5"/></svg>';
      return '<li><a class="sr-item sr-' + d.kind + '" href="' + esc(d.url) + '"><span class="sr-thumb">' + thumb + '</span>' +
        '<span class="sr-txt"><span class="sr-name">' + mark(d.name, q) + '</span>' + (d.sub ? '<span class="sr-sub">' + esc(d.sub) + '</span>' : '') + '</span>' +
        (d.price ? '<span class="sr-price">' + d.price + '</span>' : '') + '</a></li>';
    }
    var GROUPS = [['brand', 'Brands'], ['product', 'Cigars and packs'], ['page', 'Pages']];
    function render(q, hits, limits, allLink) {
      var html = '', total = 0;
      GROUPS.forEach(function (g) {
        var list = hits.filter(function (d) { return d.kind === g[0]; });
        if (!list.length) return;
        total += list.length;
        html += '<section class="sr-group"><h3 class="srch-label">' + g[1] + (list.length > limits[g[0]] ? ' <span>' + list.length + '</span>' : '') + '</h3><ul class="sr-list" role="list">' +
          list.slice(0, limits[g[0]]).map(function (d) { return item(d, q); }).join('') + '</ul></section>';
      });
      if (!total) {
        html = '<p class="sr-none">Nothing matched “' + esc(q) + '”. Try a brand (EGO, II Saints, CSB), a size (Toro, Robusto, 54) or <a href="' + esc(R.shop || '/collections/all') + '">browse every brand</a>.</p>';
      } else if (allLink) {
        html += '<a class="sr-all text-link" href="' + esc((R.search || '/search') + '?q=' + encodeURIComponent(q)) + '">' + (total > 1 ? 'See all ' + total + ' results for “' + esc(q) + '”' : 'Open the search page for “' + esc(q) + '”') + '</a>';
      }
      return { html: html, total: total };
    }

    /* the panel */
    if (dlg && typeof dlg.showModal === 'function') {
      var input = $('#srch-q', dlg), results = $('#srch-results', dlg), start = $('#srch-start', dlg), status = $('#srch-status', dlg);
      var timer, last = '';
      function run() {
        var q = input.value.trim();
        if (q === last) return;
        last = q;
        if (!q) { results.hidden = true; results.innerHTML = ''; start.hidden = false; status.textContent = ''; return; }
        load().then(function (docs) {
          if (input.value.trim() !== q) return;
          var r = render(q, find(q, docs), { brand: 4, product: 8, page: 3 }, true);
          results.innerHTML = r.html; results.hidden = false; start.hidden = true;
          status.textContent = r.total ? r.total + ' result' + (r.total === 1 ? '' : 's') : 'No results';
        }).catch(function () { status.textContent = 'Press Enter to search the shop.'; });
      }
      function open(e) {
        if (e) e.preventDefault();
        if (dlg.open) return;
        dlg.showModal(); document.body.classList.add('locked');
        load().catch(function () { /* Enter still goes to the search page */ });
        setTimeout(function () { input.focus(); input.select(); }, 30);
      }
      on(btn, 'click', open);
      on(btn, 'pointerenter', function () { load().catch(function () {}); }, { once: true });
      on(dlg, 'close', function () { document.body.classList.remove('locked'); });
      on(dlg, 'click', function (e) { if (e.target === dlg) dlg.close(); });
      on(input, 'input', function () { clearTimeout(timer); timer = setTimeout(run, 90); });
      on(start, 'click', function (e) {
        var c = e.target.closest('[data-q]'); if (!c) return;
        input.value = c.getAttribute('data-q'); run(); input.focus();
      });
      /* arrows move between the input and the results; Enter on the input opens the search page */
      on(dlg, 'keydown', function (e) {
        if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
        var links = $$('.sr-item, .sr-all', results).filter(function (a) { return a.offsetParent; });
        if (!links.length) return;
        var i = links.indexOf(document.activeElement);
        e.preventDefault();
        if (e.key === 'ArrowDown') (links[i + 1] || links[0]).focus();
        else if (i <= 0) input.focus();
        else links[i - 1].focus();
      });
      on(document, 'keydown', function (e) {
        var typing = /^(INPUT|TEXTAREA|SELECT)$/.test((e.target || {}).tagName || '') || (e.target && e.target.isContentEditable);
        if ((e.key === 'k' && (e.metaKey || e.ctrlKey)) || (e.key === '/' && !typing)) {
          if (document.querySelector('dialog[open]:not(#srch)')) return;
          open(e);
        }
      });
    }

    /* the search page: the same search over everything, in place of Shopify's plain list */
    if (page) {
      var q = page.getAttribute('data-q') || '';
      if (!q.trim()) return;
      load().then(function (docs) {
        var r = render(q, find(q, docs), { brand: 12, product: 120, page: 12 }, false);
        if (!r.total) return;
        page.innerHTML = '<p class="lede center search-count">' + r.total + ' result' + (r.total === 1 ? '' : 's') + ' for “' + esc(q) + '”</p>' + r.html;
        page.hidden = false;
        var server = $('#search-server'); if (server) server.hidden = true;
      }).catch(function () { /* Shopify's own results stay */ });
    }
  })();

  /* ------------------------------------------------- date of birth before checkout */
  $$('[data-age-check]').forEach(function (fs) {
    var form = fs.closest('form'); if (!form) return;
    var ins = $$('[data-dob]', fs), hidden = $('[data-dob-value]', fs), ok = $('[data-age-ok]', fs);
    var prev = (hidden.value || '').split('/');
    if (prev.length === 3) { ins[0].value = prev[0]; ins[1].value = prev[1]; ins[2].value = prev[2]; }
    ins.forEach(function (inp, i) {
      on(inp, 'input', function () { inp.value = inp.value.replace(/\D/g, ''); if (inp.value.length === inp.maxLength && ins[i + 1]) ins[i + 1].focus(); });
    });
    on(form, 'submit', function (e) {
      if (e.submitter && e.submitter.name && e.submitter.name !== 'checkout') return;
      var msg = $('.form-msg', form);
      var m = ins[0].value, d = ins[1].value, y = ins[2].value, age = ageFrom(m, d, y);
      if (age === null) { e.preventDefault(); say(msg, 'Enter your date of birth to continue to checkout.', true); ins[0].focus(); return; }
      if (age < MIN_AGE) { e.preventDefault(); say(msg, 'We can only sell to adults ' + MIN_AGE + ' or older.', true); return; }
      if (!ok.checked) { e.preventDefault(); say(msg, 'Please confirm you are ' + MIN_AGE + ' or older.', true); ok.focus(); return; }
      function pad(x) { return ('0' + x).slice(-2); }
      hidden.value = pad(m) + '/' + pad(d) + '/' + y;
      say(msg, 'Taking you to checkout…');
    });
  });
})();
